module.exports = __webpack_public_path__ + "images/next-month-arrow.png";